import './LoadingSpinner.css';

function LoadingSpinner(): JSX.Element {
  return <div className="spinner"></div>;
}

export default LoadingSpinner;
